import { Box } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type ActiveCellValue = Union.Nullable<boolean>;

interface ActiveCellProps<R extends GridValidRowModel = any> {
  value: ActiveCellValue;
  row: R;
}

export const ActiveCell = <R extends GridValidRowModel = any>({ value }: ActiveCellProps<R>) => {
  return (
    <>
      {isNil(value) ? (
        NULLISH_CELL_VALUE
      ) : (
        <Box
          sx={{
            display: 'inline-block',
            width: 8,
            height: 8,
            bgcolor: value ? 'text.primary' : undefined,
            border: 1,
            borderColor: 'text.primary',
            borderRadius: '50%',
          }}
        />
      )}
    </>
  );
};
